module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-copy"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h1', [_vm._v("Please download latest OpenCabana Guest App!")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/opencabana/id1267799200?mt=8&ign-mpt=uo%3D4"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.applePlayBtn
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "app-store-button",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.opencabanaguest"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.googlePlayBtn
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48a025c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/apps.vue
// module id = 595
// module chunks = 2